"use client";
import Image from "next/image";
import toast, { Toaster } from "react-hot-toast";

import Select from "react-select";
import { useBookingEngineContext } from "../../cin_context/BookingEngineContext";
import React, { useState, useRef, useEffect, useMemo } from "react";
import { v4 as uuidv4 } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { X } from "lucide-react";
const StayStepRoomManager = (
    {onRoomChange, backgroundColor, onClose}) => {
  const {
    selectedRooms,
    setSelectedRooms,
    childAge, setChildAge,
    selectedRoom,
    setSelectedRoom,
    setRoomsChange,
    isRoomsChange,
    isStayStepOpen, setIsStayStepOpen
  } = useBookingEngineContext();
  const [isToggled, setIsToggled] = useState(false);
  const [isRoomsClose, setIsRoomsClose] = useState(true);
  const containerRef = useRef(null);

  const rooms = useMemo(() => selectedRooms || [], [selectedRooms]);
  const room = useMemo(() => selectedRoom || [], [selectedRoom]);

  // Ensure default room with 1 adult
  useEffect(() => {
    if (rooms.length === 0) {
      setSelectedRooms([{ id: uuidv4(), adults: 2, children: 0, childAges: [] }]);
    }
  }, [rooms, setSelectedRooms]);

  // const addRoom = () => {
  //   if (rooms.length < 10) {
  //     onRoomChange();
  //     const id = uuidv4();
  //     setRoomsChange(!isRoomsChange);
  //     setSelectedRooms((prev) => [...prev, { id: id, adults: 1, children: 0 }]);
  //     setSelectedRoom((prev) => [
  //       ...prev,
  //       {
  //         id: id,
  //         ...lastRoom,
  //       },
  //     ]);
  //   } else {
  //     toast.error("Maximum of 10 rooms can be added.");
  //   }
  // };

  const updateChildAge = (roomId, childIndex, age) => {

    setSelectedRooms(prev =>
        prev.map(room => {

            if (room.id !== roomId)
                return room;

            const childAges = [...room.childAges];
            childAges[childIndex] = age;

            return {
                ...room,
                childAges
            };
        })
    );

    setSelectedRoom(prev =>
        prev.map(room => {

            if (room.id !== roomId)
                return room;

            const childAges = [...room.childAges];
            childAges[childIndex] = age;

            return {
                ...room,
                childAges
            };
        })
    );
    
    setRoomsChange(!isRoomsChange);
    setIsStayStepOpen(true);
};

const addRoom = () => {
  if (rooms.length < 10) {
    onRoomChange();
    const id = uuidv4();
    setRoomsChange(!isRoomsChange);
    setIsStayStepOpen(true);

    setSelectedRooms((prev) => [
      ...prev,
      { id: id, adults: 2, children: 0, childAges: [] },
    ]);

    setSelectedRoom((prev) => {
      const lastRoom = prev[prev.length - 1]; // get last room data
      return [
        ...prev,
        {
          ...lastRoom,  // copy all values
          id: id,       // only replace id
        },
      ];
    });
  } else {
    toast.error("Maximum of 10 rooms can be added.");
  }
};

  // const updateRoom = (roomId, type, value) => {
  //   if (type !== "adults" && type !== "children") {
  //     console.error("Invalid type:", type);
  //     return;
  //   }

  //   setSelectedRooms((prev) =>
  //     prev.map((room) =>
  //       room.id === roomId
  //         ? {
  //             ...room,
  //             [type]:
  //               type === "adults" ? Math.max(1, value) : Math.max(0, value),
  //           }
  //         : room
  //     )
  //   );

  //   setSelectedRoom((prev) =>
  //     prev.map((room) =>
  //       room.id === roomId
  //         ? {
  //             ...room,
  //             [type]:
  //               type === "adults" ? Math.max(1, value) : Math.max(0, value),
  //           }
  //         : room
  //     )
  //   );

  //   setRoomsChange(!isRoomsChange);
  //   setIsStayStepOpen(true);
  // };

  
  const updateRoom = (roomId, type, value) => {
    
    if (type !== "adults" && type !== "children") {
      console.error("Invalid type:", type);
      return;
    }

    setSelectedRooms(prev =>
        prev.map(room => {

            if (room.id !== roomId)
                return room;

            if (type === "children") {

                const children = Math.max(0, value);

                let childAges = [...room.childAges];

                // Add empty age entries
                while (childAges.length < children)
                    childAges.push("");

                // Remove extra ages
                while (childAges.length > children)
                    childAges.pop();

                return {
                    ...room,
                    children,
                    childAges
                };
            }

            return {
                ...room,
                adults: Math.max(1, value)
            };
        })
    );

    setSelectedRoom(prev =>
        prev.map(room => {

            if (room.id !== roomId)
                return room;

            if (type === "children") {

                const children = Math.max(0, value);

                let childAges = [...room.childAges];

                while (childAges.length < children)
                    childAges.push("");

                while (childAges.length > children)
                    childAges.pop();

                return {
                    ...room,
                    children,
                    childAges
                };
            }

            return {
                ...room,
                adults: Math.max(1, value)
            };
        })
    );

    
};
  const removeRoom = (roomId) => {
    setSelectedRooms((prev) => prev.filter((rooms) => rooms.id !== roomId));
    setSelectedRoom((prev) => prev.filter((room) => room.id !== roomId));
    setRoomsChange(!isRoomsChange);
    setIsStayStepOpen(true);
  };

  const totalAdults = rooms.reduce((sum, room) => sum + room.adults, 0);
  const totalChildren = rooms.reduce((sum, room) => sum + room.children, 0);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target) &&
        !event.target.closest(".form-control")
      ) {
        setIsToggled(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const closeRoomChange = () => {
    onClose();
    setIsRoomsClose(false);
  };
  return (
    <>
      {isRoomsClose && (
        <div className="mb-3 mb-md-0">
          <div className="book-room my-0">
            <div className="row">
              {/*<div
                className="room-manager-close-icon"
                onClick={closeRoomChange}
              >
                CLOSE{" "}
                 <Image
                  alt="close icon"
                  width="25"
                  height="25"
                  src="../images/white_close_icon.svg"
                  style={{ width: "25px", height: "25px" }}
                />
              </div> */}
              <div className="roomsDropdown" id="roomsDropdown">
                <div className="card card-body" ref={containerRef}>
                   <div
                      className="room-manager-close-icon child-staystep-inner"
                      onClick={closeRoomChange}
                    >
                      <X size={20} strokeWidth={2} className="pointer-events-none" />{" "}
                    </div>
                  {rooms.map((room, index) => (
                    <div key={room.id} className="room mb-3 border-bottom pb-2">
                      <div className="d-flex justify-content-between align-items-start">
                        <p className="fw-bold">{`Room ${index + 1}`}</p>
                        {rooms.length > 1 && (
                          <button
                            onClick={() => removeRoom(room.id)}
                            className="btn-close remove-room"
                          >
                            x
                          </button>
                        )}
                      </div>
                      <div className="row m-0">
                        <div className="col-6 px-2">
                          <div className="d-flex align-items-center justify-content-evenly">
                            <button
                              onClick={() =>
                                updateRoom(room.id, "adults", room.adults - 1)
                              }
                              className="btn btn-outline-secondary btn-minus"
                            >
                              {/* <Image
                                src="/images/minus-icon.svg"
                                alt="minus-icon"
                                className="img-fluid"
                                height={20}
                                width={20}
                              /> */}
                              <FontAwesomeIcon icon={faMinus} />
                            </button>
                            <span className="form-control text-center mx-0 adult-count">{`Adults: ${room.adults}`}</span>
                            <button
                              className="btn btn-outline-secondary btn-plus"
                              onClick={() =>
                                updateRoom(room.id, "adults", room.adults + 1)
                              }
                              disabled={room.adults >= 7}
                            >
                              {/* <Image
                                src="/images/plus-icon.svg"
                                alt="plus-icon"
                                className="img-fluid"
                                height={20}
                                width={20}
                              /> */}

                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                          </div>
                        </div>
                        <hr className="vertical-hr"></hr>
                        <div className="col-6 px-2">
                          <div className="d-flex align-items-center justify-content-evenly">
                            <button
                              className="btn btn-outline-secondary btn-minus"
                              onClick={() =>
                                updateRoom(
                                  room.id,
                                  "children",
                                  room.children - 1
                                )
                              }
                            >
                              {/* <Image
                                src="/images/minus-icon.svg"
                                alt="minus-icon"
                                className="img-fluid"
                                height={20}
                                width={20}
                              /> */}

                              <FontAwesomeIcon icon={faMinus} />
                            </button>
                            <div className="flex-column">
                              <span className="form-control d-inline-block text-center mx-0 child-count">{`Children: ${room.children}`}</span>
                              <span className="age-count">(0 - {childAge} yrs)</span>
                            </div>
                            <button
                              className="btn btn-outline-secondary btn-plus"
                              onClick={() =>
                                updateRoom(
                                  room.id,
                                  "children",
                                  room.children + 1
                                )
                              }
                              disabled={room.children >= 5}
                            >
                              {/* <Image
                                src="/images/plus-icon.svg"
                                alt="minus-icon"
                                className="img-fluid"
                                height={20}
                                width={20}
                              /> */}

                              <FontAwesomeIcon icon={faPlus} />
                            </button>
                          </div>
                        </div>
                      </div>
                      
{/* {room.children > 0 && (
  <div className="child-age-container">
    {room.childAges.map((age, childIndex) => (
      <div className="child-age-item" key={childIndex}>
        <label className="child-age-label">
          Child {childIndex + 1} Age <span className="text-danger">*</span>
        </label>

        <select
          className="form-select form-select-sm"
          value={age}
          onChange={(e) =>
            updateChildAge(room.id, childIndex, e.target.value)
          }
        >
          <option value="">Select Age</option>

          {Array.from({ length: childAge + 1 }, (_, i) => (
            <option key={i} value={i}>
              {i}
            </option>
          ))}
        </select>
      </div>
    ))}
  </div>
)} */}

{room.children > 0 && (
  <div className="child-age-container">
    {room.childAges.map((age, childIndex) => {
const ageOptions = [
  { value: "", label: "Select Age", isDisabled: true },
  ...Array.from({ length: childAge + 1 }, (_, i) => ({
    value: i,
    label: i.toString(),
  })),
];
    
  return (   
  <div className="child-age-item" key={childIndex}>
    <label className="child-age-label">
        Child {childIndex + 1} Age <span className="text-danger">*</span>
    </label>

    <Select
  className="child-age-select"
  classNamePrefix="child-age"
  isSearchable={false}
  options={ageOptions}
  // placeholder="Select Age"
  value={
  age === "" || age === undefined
    ? ageOptions[0]
    : ageOptions.find(o => o.value === Number(age))
}
  onChange={(selectedOption) =>
    updateChildAge(
      room.id,
      childIndex,
      selectedOption ? selectedOption.value : ""
    )
  }

  //menuPortalTarget={document.body}
  menuPosition="fixed"
  isOptionDisabled={(option) => option.isDisabled}

  styles={{
  control: (base, state) => ({
    ...base,
    minHeight: 28,
    height: 28,
    borderColor: backgroundColor || "#f26624",
    boxShadow: state.isFocused
      ? `0 0 0 1px ${backgroundColor || "#f26624"}`
      : "none",
    "&:hover": {
      borderColor: backgroundColor || "#f26624",
    },
  }),

  valueContainer: (base) => ({
    ...base,
    height: 28,
    padding: "0 8px",
  }),

  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),

  indicatorsContainer: (base) => ({
    ...base,
    height: 28,
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 99999,
  }),

  menu: (base) => ({
    ...base,
    zIndex: 99999,
    width: "100%",
  }),

  menuList: (base) => ({
    ...base,
    padding: 0,
  }),

  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? backgroundColor || "#f26624"
      : state.isFocused
      ? backgroundColor || "#f26624"
      : "#fff",
    color:
      state.isSelected || state.isFocused
        ? "#fff"
        : "#333",
    cursor: "pointer",
  }),
}}
/>
</div>)
})}
  </div>
)}
                    </div>
                  ))}
                  <button
                    className="btn btn-link add-room"
                    onClick={addRoom}
                    disabled={rooms.length >= 10}
                  >
                    + Add Another Room
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* <div className="col-md-12" onClick={closeRoomChange}> 
              Apply Changes
               
              </div> */}
        </div>
      )}
    </>
  );
};
export default StayStepRoomManager;
